import { API as e, Resource as t } from "@coveo/platform-client";
// src/resources/CatalogsPrivateResource.ts
var n = class n extends t {
	static {
		this.baseUrl = `/api/private/organizations/${e.orgPlaceholder}/catalog-management/catalogs`;
	}
	get(e) {
		return this.api.get(`${n.baseUrl}/${e}`);
	}
};
export { n as CatalogsPrivateResource };

//# sourceMappingURL=CatalogsPrivateResource.js.map